import type { ComponentType } from "react";

type AnyProps = Record<string, unknown>;

export interface Resolver {
  resolve: (name: string) => ComponentType<AnyProps> | undefined;
  reverseLookup: (component: ComponentType<AnyProps>) => string | undefined;
  getMap: () => Record<string, ComponentType<AnyProps>>;
}

export function createResolver(
  map: Record<string, ComponentType<AnyProps>>,
): Resolver {
  // Pre-compute reverse lookup (Component -> name)
  const reverseMap = new Map<ComponentType<AnyProps>, string>();
  for (const [name, component] of Object.entries(map)) {
    if (!reverseMap.has(component)) {
      reverseMap.set(component, name);
    }
  }

  return {
    resolve(name: string) {
      return map[name];
    },

    reverseLookup(component: ComponentType<AnyProps>) {
      return reverseMap.get(component);
    },

    getMap() {
      return map;
    },
  };
}
